import AccionesClienteIntermedioCell from "@/components/AccionesTablas/ClienteIntermedio.acciones";
import type { ClienteIntermedio } from "@interfaces/user.interface";
import type { ColumnDef } from "@tanstack/react-table";

export function getClienteIntermedioColumns(
  queryKey: ReadonlyArray<unknown>,
): ColumnDef<ClienteIntermedio>[] {
  return [
    {
      accessorKey: "usuario.id",
      header: "ID",
      enableSorting: false,
    },
    {
      accessorKey: "usuario.nombreUsuario",
      header: "Nombre de Usuario",
    },
    {
      accessorKey: "usuario.nombre",
      header: "Nombre",
    },
    {
      accessorKey: "usuario.apellidoPaterno",
      header: "Apellido Paterno",
    },
    {
      accessorKey: "usuario.apellidoMaterno",
      header: "Apellido Materno",
    },
    {
      accessorKey: "usuario.correo",
      header: "Correo",
    },
    {
      accessorKey: "nombreEmpresa",
      header: "Nombre Empresa",
    },
    {
      id: "acciones",
      header: "Acciones",
      cell: ({ row }) => (
        <AccionesClienteIntermedioCell
          cliente={row.original}
          queryKey={queryKey}
        />
      ),
    },
  ];
}
